// extracted by mini-css-extract-plugin
module.exports = {"canvas":"mesh-gradient_canvas__OvJ38","base":"mesh-gradient_base__0pCjd"};